// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Add any additional custom styles here */

/*
 * Hide the Cloudscape guided-tour hotspot trigger icon (the small "+" /
 * minus circle that sits next to a hotspot target). We keep the
 * AnnotationContext popover visible for the guided demo, but the marker
 * itself adds visual noise on a kiosk display so we suppress it.
 *
 * Use \`opacity: 0\` rather than \`display: none\` or \`visibility: hidden\`
 * so the button still occupies a layout rect — Cloudscape's popover
 * positions itself relative to that rect, so collapsing it would make
 * the popover jump to the top-left of the page.
 *
 * The class name is scoped by Cloudscape (e.g. \`.awsui_hotspot_abc123\`);
 * match any class that contains \`awsui_hotspot_\`.
 */
button[class*="awsui_hotspot_"] {
  opacity: 0 !important;
  pointer-events: none !important;
}

/*
 * Widen the guided-tour annotation popover so the step copy doesn't
 * wrap into an excessively tall column. Cloudscape's default
 * \`size="medium"\` caps the popover at 310px; bump it to 440px for the
 * kiosk demo. The class name is scoped, so target any class that
 * contains \`container-body-variant-annotation\`.
 */
[class*="awsui_container-body-variant-annotation"] {
  max-inline-size: 440px !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,0CAA0C;;AAE1C;;;;;;;;;;;;;EAaE;AACF;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;;;;;EAME;AACF;EACE,iCAAiC;AACnC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Add any additional custom styles here */\n\n/*\n * Hide the Cloudscape guided-tour hotspot trigger icon (the small \"+\" /\n * minus circle that sits next to a hotspot target). We keep the\n * AnnotationContext popover visible for the guided demo, but the marker\n * itself adds visual noise on a kiosk display so we suppress it.\n *\n * Use `opacity: 0` rather than `display: none` or `visibility: hidden`\n * so the button still occupies a layout rect — Cloudscape's popover\n * positions itself relative to that rect, so collapsing it would make\n * the popover jump to the top-left of the page.\n *\n * The class name is scoped by Cloudscape (e.g. `.awsui_hotspot_abc123`);\n * match any class that contains `awsui_hotspot_`.\n */\nbutton[class*=\"awsui_hotspot_\"] {\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/*\n * Widen the guided-tour annotation popover so the step copy doesn't\n * wrap into an excessively tall column. Cloudscape's default\n * `size=\"medium\"` caps the popover at 310px; bump it to 440px for the\n * kiosk demo. The class name is scoped, so target any class that\n * contains `container-body-variant-annotation`.\n */\n[class*=\"awsui_container-body-variant-annotation\"] {\n  max-inline-size: 440px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
